export const generateFlexCard = async (user, partyMessage, lastWorkout) => {
    return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1920; 
        const ctx = canvas.getContext('2d');

        const drawBackground = () => {
            const gradient = ctx.createLinearGradient(0, 0, 0, 1920);
            gradient.addColorStop(0, '#18181b'); 
            gradient.addColorStop(0.4, '#09090b'); 
            gradient.addColorStop(1, '#000000'); 
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, 1080, 1920);

            const glowTop = ctx.createRadialGradient(540, 200, 0, 540, 200, 800);
            glowTop.addColorStop(0, 'rgba(234, 88, 12, 0.08)'); 
            glowTop.addColorStop(1, 'rgba(0, 0, 0, 0)');
            ctx.fillStyle = glowTop;
            ctx.fillRect(0, 0, 1080, 800);

            const glowCenter = ctx.createRadialGradient(540, 1000, 0, 540, 1000, 1000);
            glowCenter.addColorStop(0, 'rgba(234, 88, 12, 0.05)');
            glowCenter.addColorStop(1, 'rgba(0, 0, 0, 0)');
            ctx.fillStyle = glowCenter;
            ctx.fillRect(0, 0, 1080, 1920);

            ctx.strokeStyle = 'rgba(255, 255, 255, 0.015)';
            ctx.lineWidth = 2;
            for(let i=0; i<1080; i+=80) { ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i, 1920); ctx.stroke(); }
            for(let j=0; j<1920; j+=80) { ctx.beginPath(); ctx.moveTo(0, j); ctx.lineTo(1080, j); ctx.stroke(); }
        };

        const drawText = (text, x, y, font, color, align = 'center', glowColor = null) => {
            ctx.font = font;
            ctx.fillStyle = color;
            ctx.textAlign = align;
            if (glowColor) {
                ctx.shadowColor = glowColor;
                ctx.shadowBlur = 15;
            } else {
                ctx.shadowBlur = 0;
            }
            ctx.fillText(text, x, y);
            ctx.shadowBlur = 0;
        };

        const fitText = (text, x, y, maxW, baseFontStr, baseSize, color, glowColor = null) => {
            let size = baseSize;
            ctx.font = baseFontStr.replace('{size}', size);
            while(ctx.measureText(text).width > maxW && size > 20) {
                size -= 2;
                ctx.font = baseFontStr.replace('{size}', size);
            }
            drawText(text, x, y, ctx.font, color, 'center', glowColor);
        };

        const wrapText = (text, x, y, maxWidth, lineHeight, font, color) => {
            ctx.font = font;
            ctx.fillStyle = color;
            ctx.textAlign = 'center';
            ctx.shadowBlur = 0;
            
            const words = text.split(' ');
            let line = '';
            let currentY = y;

            for (let n = 0; n < words.length; n++) {
                const testLine = line + words[n] + ' ';
                const metrics = ctx.measureText(testLine);
                if (metrics.width > maxWidth && n > 0) {
                    ctx.fillText(line.trim(), x, currentY);
                    line = words[n] + ' ';
                    currentY += lineHeight;
                } else {
                    line = testLine;
                }
            }
            ctx.fillText(line.trim(), x, currentY);
            return currentY;
        };

        const drawCard = (logoImg) => {
            drawBackground();

            // --- 1. HEADER ---
            let currentY = 150;
            if (logoImg) {
                ctx.drawImage(logoImg, 540 - 80, currentY - 80, 160, 160);
                currentY += 120;
            } else {
                drawText('MYWOD', 540, currentY, 'italic 900 85px sans-serif', '#ffffff');
                currentY += 60;
            }
            drawText('WORKOUT OF THE DAY', 540, currentY, '900 24px sans-serif', '#ea580c', 'center', 'rgba(234, 88, 12, 0.4)');

            // --- 2. ATLEET & DATUM ---
            currentY += 100;
            const firstName = user?.name ? user.name.split(' ')[0].toUpperCase() : 'ATHLETE';
            drawText(firstName, 540, currentY, '900 90px sans-serif', '#ffffff');
            currentY += 45;
            const today = new Date().toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }).toUpperCase();
            drawText(today, 540, currentY, 'bold 26px sans-serif', '#a1a1aa');

            // --- DATA PARSEN ---
            const rawDesc = lastWorkout?.description || '';
            let lines = rawDesc.split('\n')
                .filter(l => l.trim().startsWith('-'))
                .filter(l => !l.toLowerCase().includes('(overgeslagen)'));
            
            if (lines.length === 0) {
                lines = ["Sessie gelogd zonder actieve werksets."];
            }

            let scoreStr = 'VOLTOOID';
            const scoreMatch = rawDesc.match(/(Score:|Tijd:|Voltooid:)\s*(.*)/i);
            if (scoreMatch) {
                scoreStr = scoreMatch[2].trim().toUpperCase();
            } else if (lastWorkout?.type && lastWorkout.type.toUpperCase().includes('KRACHT')) {
                scoreStr = 'KRACHTTRAINING';
            }

            let rawType = lastWorkout?.type || 'WORKOUT';
            let subTitle = rawType.replace(/Historie:\s*/i, '').replace(/Commercial Gym\s*-\s*/i, '').toUpperCase();
            if (!subTitle || subTitle === 'KRACHTTRAINING') subTitle = 'GENERAL';
            
            // Verwijder de ingebakken tijd (Nu rawType wél bekend is!)
            if (rawType.toUpperCase() === 'FITNESS' || scoreStr.includes('KRACHT')) {
                scoreStr = scoreStr.replace(/\s*\([\d:]+\)\s*/g, '').trim();
            }

            // --- 3. DYNAMISCHE WORKOUT BOX ---
            currentY += 60;
            const boxTop = currentY;
            
            
            // Professionele "Title + Sets" layout
            const visibleLinesCount = lines.length;
            
            // Bereken de dynamische hoogte (65px per oefening inclusief sets)
            const boxHeight = 180 + (lines.length * 65) + 40;
            
            ctx.fillStyle = 'rgba(24, 24, 27, 0.6)';
            ctx.strokeStyle = 'rgba(255, 255, 255, 0.05)';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.roundRect(80, boxTop, 920, boxHeight, 20);
            ctx.fill();
            ctx.stroke();

            ctx.fillStyle = '#ea580c';
            ctx.beginPath();
            ctx.roundRect(80, boxTop, 920, 10, {tl: 20, tr: 20, bl: 0, br: 0});
            ctx.fill();

            let innerY = boxTop + 60;
            drawText('RESULTAAT', 540, innerY, 'bold 18px sans-serif', '#a1a1aa');
            innerY += 50;
            fitText(scoreStr, 540, innerY, 850, '900 {size}px sans-serif', 55, '#ffffff', 'rgba(255,255,255,0.1)');
            innerY += 35;
            drawText(subTitle, 540, innerY, 'bold 24px sans-serif', '#ea580c', 'center', 'rgba(234, 88, 12, 0.3)');

            innerY += 30;
            ctx.strokeStyle = 'rgba(255, 255, 255, 0.08)';
            ctx.beginPath(); ctx.moveTo(140, innerY); ctx.lineTo(940, innerY); ctx.stroke();

            innerY += 50;
            ctx.textAlign = 'left';

            for (let i = 0; i < lines.length; i++) {
                let rawLine = lines[i].replace(/^-/, '').trim();
                rawLine = rawLine.replace(/^[A-Z]\d?\s*-\s*/, ''); // Verwijder de "A -" letter indicatie

                // Splits in Naam en Sets
                let parts = rawLine.split(':');
                let exName = parts[0].trim();
                let exSets = parts.length > 1 ? parts.slice(1).join(':').trim() : '';

                // Vorm de komma's om naar strakke pipes
                if (exSets) {
                    exSets = exSets.split(',').map(s => s.trim()).join('   |   ');
                }

                // Teken het oranje bolletje
                ctx.fillStyle = '#ea580c';
                ctx.fillText('•', 140, innerY);

                // Teken de naam van de oefening (Dik en Wit)
                ctx.fillStyle = '#ffffff';
                ctx.font = 'bold 22px sans-serif';
                ctx.fillText(exName.toUpperCase(), 170, innerY);

                // Teken de sets er strak en grijs onder
                if (exSets) {
                    ctx.fillStyle = '#a1a1aa'; // Zinc-400
                    let setFontSize = 18;
                    ctx.font = `600 ${setFontSize}px sans-serif`;
                    
                    // Schaal ietsjes kleiner als het een gigantische reeks is (zoals 6 sets)
                    while(ctx.measureText(exSets).width > 720 && setFontSize > 12) {
                        setFontSize -= 1;
                        ctx.font = `600 ${setFontSize}px sans-serif`;
                    }
                    
                    ctx.fillText(exSets, 170, innerY + 28); // 28 pixels onder de titel
                }

                innerY += exSets ? 65 : 45; // Dynamische afstand naar de volgende oefening
            }
            if (false) { // maxLines check is verwijderd vanwege dynamische schaling
                ctx.fillStyle = '#71717a';
                ctx.font = 'italic 24px sans-serif';
                ctx.fillText(`+ nog ${lines.length - maxLines} andere oefeningen...`, 170, innerY);
            }

            // --- 4. COACH VERDICT BOX ---
            currentY = boxTop + boxHeight + 80;
            
            let isPR = partyMessage && partyMessage.includes("NIEUW PR");
            let prLinesArr = [];
            
            const epicQuotes = [
                "SUCCES IS DE SOM VAN KLEINE INSPANNINGEN.",
                "DISCIPLINE WINT ALTIJD VAN MOTIVATIE.",
                "PIJN IS TIJDELIJK. OPGEVEN IS VOOR ALTIJD.",
                "HET EGO BLIJFT BUITEN. DE RESULTATEN SPREKEN.",
                "EXCUSES BRANDEN GEEN CALORIEËN.",
                "ONLY THE STRONG SURVIVE.",
                "NOBODY CARES. TRAIN HARDER."
            ];
            
            let textToDraw = "";
            if (!isPR && partyMessage && partyMessage.length > 5 && !partyMessage.includes("LOKAAL")) {
                textToDraw = partyMessage;
            } else {
                const quoteIndex = new Date().getMinutes() % epicQuotes.length;
                textToDraw = epicQuotes[quoteIndex];
            }

            textToDraw = textToDraw.replace(/\n/g, ' ').trim().toUpperCase();

            // Bereken dynamische hoogte van de coach box o.b.v. aantal PR's
            let coachBoxHeight = 100;
            if (isPR) {
                prLinesArr = partyMessage.split('\n').filter(l => l.includes(':'));
                coachBoxHeight += 60 + (prLinesArr.length * 45); // Exta ruimte per PR
            }
            
            let estimatedLines = Math.ceil(textToDraw.length / 35);
            coachBoxHeight += (estimatedLines * 40);

            ctx.fillStyle = 'rgba(234, 88, 12, 0.04)'; 
            ctx.strokeStyle = 'rgba(234, 88, 12, 0.3)'; 
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.roundRect(80, currentY, 920, coachBoxHeight, 20);
            ctx.fill();
            ctx.stroke();

            ctx.fillStyle = '#ea580c';
            ctx.beginPath();
            ctx.roundRect(80, currentY, 12, coachBoxHeight, {tl: 20, tr: 0, bl: 20, br: 0});
            ctx.fill();

            let coachInnerY = currentY + 45;

            if (isPR) {
                const prTitle = prLinesArr.length > 1 ? "🔥 NIEUWE PR'S GEZET" : "🔥 NIEUW PR GEZET";
                drawText(prTitle, 540, coachInnerY, '900 24px sans-serif', '#f59e0b', 'center', 'rgba(245, 158, 11, 0.5)');
                coachInnerY += 45;

                // Loop door alle PR's en teken ze netjes onder elkaar (maximaal 4 om overflow te voorkomen)
                for (let i = 0; i < Math.min(prLinesArr.length, 4); i++) {
                    const fontSize = prLinesArr.length > 2 ? 28 : 34; // Maak de tekst iets kleiner als het er veel zijn
                    fitText(prLinesArr[i].toUpperCase(), 540, coachInnerY, 800, `900 {size}px sans-serif`, fontSize, '#ffffff');
                    coachInnerY += 40;
                }
                coachInnerY += 20; // Extra witruimte na de PR's
            }

            drawText('COACH VERDICT', 540, coachInnerY, '900 18px sans-serif', '#ea580c');
            wrapText(`"${textToDraw}"`, 540, coachInnerY + 45, 800, 45, 'italic 900 32px sans-serif', '#ffffff');

            // --- 5. PRO FOOTER ---
            drawText('P O W E R E D   B Y   M Y W O D', 540, 1860, '600 20px sans-serif', '#52525b');

            canvas.toBlob((blob) => resolve(blob), 'image/png');
        };

        const logoImg = new Image();
        logoImg.crossOrigin = "Anonymous";
        logoImg.onload = () => drawCard(logoImg);
        logoImg.onerror = () => drawCard(null); 
        logoImg.src = '/logo192.png';
    });
};
